export const APP_NAME = 'Udbodhanam';

export * from './dsr';
export * from './embeds';
